import { useAuth } from 'app/providers/auth/AuthProvider'
import {
  getNextZoomInInterval,
  getNextZoomOutInterval,
  type ScheduleZoomInterval,
} from '../Calendar/ZoomControls/scheduleZoomIntervals'
import { useCallback, useEffect, useRef, useState } from 'react'
import { getScheduleZoomInterval, setScheduleZoomInterval } from './scheduleZoomStorage'

export const useScheduleZoom = () => {
  const { userId } = useAuth()
  const [zoomInterval, setZoomInterval] = useState<ScheduleZoomInterval>(() =>
    getScheduleZoomInterval(userId),
  )
  const zoomIntervalRef = useRef(zoomInterval)
  zoomIntervalRef.current = zoomInterval

  useEffect(() => {
    const stored = getScheduleZoomInterval(userId)
    zoomIntervalRef.current = stored
    setZoomInterval(stored)
  }, [userId])

  const zoomIn = useCallback(() => {
    const next = setScheduleZoomInterval(userId, getNextZoomInInterval(zoomIntervalRef.current))
    zoomIntervalRef.current = next
    setZoomInterval(next)
  }, [userId])

  const zoomOut = useCallback(() => {
    const next = setScheduleZoomInterval(userId, getNextZoomOutInterval(zoomIntervalRef.current))
    zoomIntervalRef.current = next
    setZoomInterval(next)
  }, [userId])

  return { zoomInterval, zoomIn, zoomOut }
}
